import React from "react";
import Form from "react-bootstrap/Form";
import Col from "react-bootstrap/Col";  
import Row from "react-bootstrap/Row";  
import FormInput from "./FormInput";
import { Button } from "../Buttons/Button";
import { Formik } from "formik";
import PromptIfDirty from "./PromptIfDirty";
import PropTypes from "prop-types";
import { loginSchema } from "./validationSchema";
import { InfoCircleFill } from "react-bootstrap-icons";
import { propTypes } from "react-bootstrap/esm/Image";
import  { getSafeHref } from "../../utils/utils"

const DynamicForm = (props) => {
  const generateInitialValues = (fields, data) => {
    const initialValues = {};
    fields.forEach((field) => {
      if (field.type !== "button" && field.type !== "submit") {
        initialValues[field.name] =
          data?.[field.name] !== undefined ? data[field.name] : "";
      }
    });
    return initialValues;
  };

  const initialValues = generateInitialValues(props.fields, props.data);

  return (
    <Formik
      enableReinitialize
      innerRef={props.formikRef}
      initialValues={initialValues}
      onSubmit={(values, formikBag) => {
        delete values.undefined;
        props.onSubmit?.(values, formikBag);
        if (props.resetOnSubmit) {
          formikBag.resetForm();
        }
      }}
      validationSchema={props.validationSchema}
      validateOnChange={props.validateOnChange || false}
    >
      {({ handleSubmit, handleChange, values, touched, errors }) => {
        if (props.onErrorChange) {
          props.onErrorChange(errors, touched);
        }

        // Separate button/submit fields from input fields
        const inputFields = props.fields.filter(
          (f) => f.type !== "button" && f.type !== "submit"
        );
        const buttonFields = props.fields.filter(
          (f) => f.type === "button" || f.type === "submit"
        );

        return (
          <Form
            className="text-left form-wrapper"
            noValidate
            onSubmit={handleSubmit}
          >
            {props.askConfirmation && <PromptIfDirty />}

            {/* Input fields rendered inside a Row to support colSize */}
            <Row>
              {inputFields.map((field) => (
                <Col
                  key={field.controlId}
                  xs={12}
                  md={field.colSize ? field.colSize : 12}
                className="mb-2">
                  <Form.Group>
                    <FormInput
                      className="inputs form-group"
                      error={errors[field.name]}
                      onChange={(e) => {
                        handleChange(e);
                        if (props.onChange) {
                          props.onChange(e.target.name, e.target.value);
                        }
                      }}
                      touched={touched[field.name]}
                      type={field.type}
                      value={values[field.name]}
                      {...field}
                    />
                  </Form.Group>
                </Col>
              ))}
            </Row>
              {/* Button/submit fields rendered full width below */}
              {props.isChangePassword && <hr />}
            {buttonFields.map((field) => (
              <Form.Group key={field.controlId}>
                <div className="form-group">
                  {props.serverError && (
                    <div className="server-error">
                      <InfoCircleFill /> {props.serverError}
                    </div>
                  )}
                  <Button
                    className={field.className}
                    href={getSafeHref(field?.href)}
                    label={field.label}
                    size={field.size}
                    type={field.type}
                    variant={field.variant}
                  />
                </div>
              </Form.Group>
            ))}
          </Form>
        );
      }}
    </Formik>
  );
};

DynamicForm.defaultProps = {
  fields: [],
  validationSchema: loginSchema,
  onSubmit: undefined,
  askConfirmation: false,
  validateOnChange: false,
  resetOnSubmit: false,
};

DynamicForm.propTypes = {
  validationSchema: PropTypes.objectOf(PropTypes.any),
  validateOnChange: PropTypes.bool,
  fields: PropTypes.arrayOf(PropTypes.object),
  onSubmit: PropTypes.func,
  onChange: PropTypes.func,
  data: PropTypes.object,
  askConfirmation: PropTypes.bool,
  onErrorChange: PropTypes.func,
  serverError: propTypes.string,
  resetOnSubmit: PropTypes.bool,
};

export default DynamicForm;